module.exports = __webpack_public_path__ + "img/image-stable-dd9c9250.png";